// Org-scoped authority in Hub is expressed as `org-admin:<capability>` claims. Holding any
// one of them is what separates an administrator from a plain member — the specific
// capability only matters at the point of the individual action.
export const ORG_ADMIN_PREFIX = 'org-admin:';
// Cloudhouse staff authority (the staff console), granted within the Cloudhouse WorkOS org.
export const CLOUDHOUSE_ADMIN_PREFIX = 'cloudhouse-admin:';

// UX gate only — the entitlements API's own permission checks are the real control.
export function isOrgAdmin(permissions: readonly string[] | null | undefined): boolean {
  return (permissions ?? []).some((p) => p.startsWith(ORG_ADMIN_PREFIX));
}

export function isCloudhouseAdmin(permissions: readonly string[] | null | undefined): boolean {
  return (permissions ?? []).some((p) => p.startsWith(CLOUDHOUSE_ADMIN_PREFIX));
}
